import * as React from 'react';
import { SVGProps } from 'react';

const IconTableSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10H2V2h8v8ZM9 3H6.5v2.5H9V3ZM3 6.5V9h2.5V6.5H3Zm2.5-1H3V3h2.5v2.5Zm1 1V9H9V6.5H6.5Z"
    />
  </svg>
);
export default IconTableSizeXs;
